import { useState, useEffect } from 'react';

export const useMobileDetection = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 900;
      setIsMobile(mobile);
      
      if (mobile) {
        // 모바일 환경에서 랜딩페이지 스크롤 활성화
        document.documentElement.classList.add('landing-page');
        document.body.classList.add('landing-page');
        document.getElementById('root')?.classList.add('landing-page');
      } else {
        // PC 환경에서는 클래스 제거
        document.documentElement.classList.remove('landing-page');
        document.body.classList.remove('landing-page');
        document.getElementById('root')?.classList.remove('landing-page');
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
      // 컴포넌트 언마운트 시 클래스 정리
      document.documentElement.classList.remove('landing-page');
      document.body.classList.remove('landing-page');
      document.getElementById('root')?.classList.remove('landing-page');
    };
  }, []);

  return isMobile;
}; 